import React from 'react';
import { Box } from '@mui/material';
import { SlideObject } from '../types';
import { imageCropStyle } from './objectTransform';
import { isLineShape, shapeClipPathCss } from './shapeFrame';
import { shapeSvgMarkup } from './shapeSvg';
import { resolveMediaUrl } from './slidePreview';

interface ShapeObjectViewProps {
  object: SlideObject;
  children?: React.ReactNode;
}

const svgBoxSx = { width: '100%', height: '100%', '& svg': { display: 'block', overflow: 'visible' } };

const ShapeObjectView: React.FC<ShapeObjectViewProps> = ({ object, children }) => {
  if (isLineShape(object.style)) {
    return (
      <Box
        sx={{ ...svgBoxSx, pointerEvents: 'none' }}
        dangerouslySetInnerHTML={{ __html: shapeSvgMarkup(object.w, object.h, object.style) }}
      />
    );
  }

  const clipPath = shapeClipPathCss(object.w, object.h, object.style);
  return (
    <Box sx={{ width: '100%', height: '100%', position: 'relative' }}>
      <Box sx={{ position: 'absolute', inset: 0, overflow: 'hidden', clipPath }}>
        <Box
          sx={{ ...svgBoxSx, pointerEvents: 'none' }}
          dangerouslySetInnerHTML={{ __html: shapeSvgMarkup(object.w, object.h, object.style, { fill: true, stroke: false }) }}
        />
        {object.imageUrl ? (
          <Box sx={{ position: 'absolute', inset: 0 }}>
            <Box
              component="img"
              src={resolveMediaUrl(object.imageUrl)}
              alt=""
              sx={{ display: 'block', pointerEvents: 'none', ...imageCropStyle(object.style) }}
            />
          </Box>
        ) : null}
      </Box>
      <Box
        sx={{ position: 'absolute', inset: 0, pointerEvents: 'none', ...svgBoxSx }}
        dangerouslySetInnerHTML={{ __html: shapeSvgMarkup(object.w, object.h, object.style, { fill: false, stroke: true }) }}
      />
      {children}
    </Box>
  );
};

export default ShapeObjectView;
